import { render, staticRenderFns } from "./BranchCanceled.vue?vue&type=template&id=820e8ec4&"
import script from "./BranchCanceled.vue?vue&type=script&lang=js&"
export * from "./BranchCanceled.vue?vue&type=script&lang=js&"
import style0 from "./BranchCanceled.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports